/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { change_requests_AllergyChangeField } from './change_requests_AllergyChangeField';
import type { change_requests_ContactPermissionChangeField } from './change_requests_ContactPermissionChangeField';
import type { change_requests_MedicalChangeField } from './change_requests_MedicalChangeField';
export type change_requests_ChangeRequestField = {
    /**
     * allergy sub_type
     */
    allergy?: change_requests_AllergyChangeField;
    /**
     * comment sub_type
     */
    comment_field?: change_requests_ChangeRequestField.comment_field;
    comment_value?: string;
    /**
     * contact_pickup / contact_emergency sub_types
     */
    contact?: change_requests_ContactPermissionChangeField;
    /**
     * medical sub_type
     */
    medical?: change_requests_MedicalChangeField;
};
export namespace change_requests_ChangeRequestField {
    /**
     * comment sub_type
     */
    export enum comment_field {
        NOTES = 'notes',
        SPECIAL_CARE = 'special_care',
        NOTE_EMERGENCY_LIST = 'note_emergency_list',
        LANGUAGE_REQUEST = 'language_request',
        SLEEP_REQUEST = 'sleep_request',
        EATING_REQUEST = 'eating_request',
        TOILET_REQUEST = 'toilet_request',
        MISC_REQUEST = 'misc_request',
        VACCINATION_COMMENT = 'vaccination_comment',
    }
}

